export default __webpack_public_path__ + "static/media/second_choose.612fc71a.png";